import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { SvgIconsService } from '@aeCore/services/svg-icons.service';
import { LoadingService } from '@aeCore/services/loading.service';
import { AsyncPipe } from '@angular/common';
import { AeIconsComponent } from '@aeShared/components/ae-icons/ae-icons.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterModule, AsyncPipe, AeIconsComponent],
  templateUrl: './app.component.html',
  standalone: true,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'aeda-admin-fe';

  constructor(
    private svgIconService: SvgIconsService,
    public loadingService: LoadingService,
  ) {
    this.svgIconService.loadSvgSprite('assets/ae-icons.svg');
  }
}
